"use client";

/* eslint-disable */
import { useState, useEffect, useRef } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "../Generales/Header/Header.jsx";
import HeaderLinks from "../Generales/Header/HeaderLinks.jsx";
import Table from "components/Table/Table.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import UsuarioBlanco from "assets/img/faces/UsuarioBlanco1.png";
import BannerPerfilArtistas from "assets/img/terco-img/BannerPerfilArtistas.jpg";
import Camisa from "@icons/material/TshirtCrewIcon";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.jsx";
import Cookies from "js-cookie";
import {
	Edit,
	ShoppingBasket,
	AccountCircle,
	CardMembership,
	AttachMoney,
	StoreMallDirectory,
	Delete,
	Save,
	Close,
	Grade,
	Mail,
} from "@material-ui/icons";
import ModalEditar from "./ModalEditar";
import ModalCancelar from "./ModalCancelarPedido";
import ModalEliminarDiseño from "./ModalEliminarDiseño";
import ModalCancelarMembresia from "../Generales/Modales/ModalAccion";
import ModalEliminarCuenta from "./ModalEliminarCuenta";
import DetalleVenta from "./ModalDetallesCompra";
import TiendaArtista from "./TiendaArtista";
import ModalAgregarTienda from "./ModalAgregarTienda";
import ModalCargando from "../Generales/Modales/ModalCargando";
import Loader from "react-loader-spinner";
import ModalMembresia from "./ModalExitoMembresia";
import ModalCorreoOxxo from "./ModalCorreoOxxo";
import Globales from "utils/Globales";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { InfiniteLoader } from "components/InfiniteLoader/InfiniteLoader.jsx";
import { makePageFetcher } from "api/makePageFetcher";
import { urlMakePageFetcherShopping } from "api/shopping/index.js";
import { urlMakePageFetcherDesigns } from "api/desings/index.js";
import { usersApi } from "api/users/index.js";
import { useUserStore } from "stores/userStore.js";
import { useOrderStore } from "stores/orderStore.js";
import { useDesingStore } from "stores/desingStore.js";
import { PurchaseSkeletonCard } from "components/PurchaseCardBase/PurchaseSkeletonCard.jsx";

const createFetchShopping = (filtros = {}) => {
	return makePageFetcher({
		url: urlMakePageFetcherShopping.url,
		method: urlMakePageFetcherShopping.method,
		staticPayload: filtros,
		dataPath: "Purchases",
		totalPath: "Total",
		pageField: "page",
		limitField: "perPage",
		filtersKey: "idUser",
		serializeFiltersAsJson: true,
	});
};

const createFetchDesigns = (filtros = {}) => {
	return makePageFetcher({
		url: urlMakePageFetcherDesigns.url,
		method: urlMakePageFetcherDesigns.method,
		staticPayload: filtros,
		dataPath: "Designs",
		totalPath: "Total",
		pageField: "page",
		limitField: "perPage",
		filtersKey: "idUser",
		serializeFiltersAsJson: true,
	});
};

export const fetchShopping = createFetchShopping();
export const fetchDesigns = createFetchDesigns();

const conektaHelper = {
	initConekta: () => {
		if (window.Conekta) {
			window.Conekta.setPublicKey(Globales.KeyConekta);
		}
	},
	getCardBrand: (cardNumber) => {
		if (window.Conekta && window.Conekta.card) {
			return window.Conekta.card.getBrand(cardNumber);
		}
		return null;
	},
	validateCardNumber: (cardNumber) => {
		if (window.Conekta && window.Conekta.card) {
			return window.Conekta.card.validateNumber(cardNumber);
		}
		return false;
	},
	validateCvc: (cvc) => {
		if (window.Conekta && window.Conekta.card) {
			return window.Conekta.card.validateCVC(cvc);
		}
		return false;
	},
	validateExpirationDate: (expiryMonth, expiryYear) => {
		if (window.Conekta && window.Conekta.card) {
			return window.Conekta.card.validateExpirationDate(
				expiryMonth,
				`20${expiryYear}`
			);
		}
		return false;
	},
	tokenize: (
		cardNumber,
		cardHolder,
		expiryMonth,
		expiryYear,
		cvc,
		successCallback,
		errorCallback
	) => {
		if (!window.Conekta || !window.Conekta.Token) {
			if (errorCallback) {
				errorCallback({ message: "Conekta no está cargado" });
			}
			return;
		}
		const tokenParams = {
			card: {
				number: cardNumber,
				name: cardHolder,
				exp_year: expiryYear,
				exp_month: expiryMonth,
				cvc,
			},
		};
		window.Conekta.Token.create(tokenParams, successCallback, errorCallback);
	},
};

const ProfilePage = (props) => {
	const { classes, ...rest } = props;
	const { userState } = useUserStore();
	const {
		desingState,
		setDesingState,
		setDesing,
		clearDesing,
	} = useDesingStore();

	// Refs
	const loaderDesignRef = useRef(null);
	const loaderOrdersRef = useRef(null);
	const alertTimeoutRef = useRef(null);

	// State
	const [state, setState] = useState({
		BajaMembresia: false,
		DatosMembresia: {},
		EsRedSocial: true,
		CargandoVentas: false,
		CargandoCompras: false,
		IndicadorTerco: false,
		DisenosGrupo: [],
		VerAgregarTienda: false,
		PrecioMembresia: 0,
		PrecioMembresiaDescuento: -1,
		DescuentoMembresia: 0,
		idPedidoCancelacion: "",
		VerTabs: false,
		Membresia: null,
		IndexTabCliente: 1,
		IndexTabArtista: 2,
		VerTienda: true,
		DetallesVenta: {},
		VerModalCancelar: false,
		FechaParaCancelar: "",
		Disenos: [],
		Ventas: [],
		NumeroTarjetaComision: "",
		BancoComision: "",
		NombreEmpresa: "",
		Saldo: 0,
		Portada: "",
		FotoPerfil: "",
		Logo: "",
		Usuario: userState,
		VerDetalleCompra: false,
		Compras: [],
		TituloModal: "",
		show: false,
		id: "",
		Nombre: "",
		Correo: "",
		ConfirmacionContrasena: "",
		TipoUsuario: "",
		TipoUsuarioActual: "",
		CuentaBancaria: "",
		Telefono: "",
		ContraseniaActual: "",
		ContrasenaNueva: "",
		mensaje: "",
		ImagenPortada: [],
		ListaPortada: [],
		ImagenSubida: "",
		VerBotonFotoPerfil: false,
		br: false,
		FechaVencimientoMembresia: "",
		EsVenta: false,
		VerModalMembresia: false,
		VerTiendaArtista: false,
		CuerpoCargando: "",
		VerCargando: "",
		SeleccionDisenos: true,
		SeleccionFavoritos: false,
		VerModalCancelarMembresia: false,
		VerModalCorreo: false,
		VerModalEliminarCuenta: false,
		ImporteComisionesPendientes: 0,
		NumeroTarjeta: "",
		NombreTitular: "",
		CodigoSeguridad: "",
		FechaExpiracion: "",
		Mes: "",
		Año: "",
		NombreCliente: "",
		CorreoCliente: "",
		error: {
			NumeroTarjeta: false,
			NombreTitular: false,
			CodigoSeguridad: false,
			FechaExpiracion: false,
			Mes: false,
			Año: false,
			NombreCliente: false,
			CorreoCliente: false,
		},
		colorNotificacion: "success",
		errorNombre: false,
		errorCorreo: false,
		errorTelefono: false,
		errorCuentaBancaria: false,
		errorUsuarioLogin: false,
		errorContrasenaAnteriorLogin: false,
		errorUsuario: false,
		errorContrasenaAnterior: false,
		errorConfirmacionContrasena: false,
		errorTipoUsuario: false,
		errorNumeroTarjetaComision: false,
		errorBancoComision: false,
		isRequireDatosTarjetaMembresia: false,
		cargandoDisenios: true,
		currentPage: 1,
		itemsPerPage: 12,
		totalProductos: 0,
		infinitKeyShopping: 0,
		infinitKeyDesigns: 0,
		fetchPageFunction: fetchShopping,
		fetchDesignsFunction: fetchDesigns,
		VerModalEliminarDiseno: false,
		idDisenoEliminar: "",
		DetallesCompra: {},
		RutaPortada: "",
		RutaFotoPerfil: "",
		RutaLogo: "",
	});

	// componentWillMount equivalent
	useEffect(() => {
		clearDesing();
		if (userState.type == "Cliente") {
			setState((prev) => ({ ...prev, TipoUsuario: "Cliente" }));
		}
		if (userState.type == "Artista") {
			setState((prev) => ({ ...prev, TipoUsuario: "Artista" }));
		}

		var idCliente = "";
		if (props.match?.params?.id !== undefined) {
			setState((prev) => ({
				...prev,
				VerTiendaArtista: true,
				id: props.match.params.id,
			}));
			idCliente = props.match.params.id;
		} else {
			idCliente = userState.id;
		}

		ObtenerInformacionCliente(idCliente);
	}, []);

	// componentDidMount equivalent
	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://cdn.conekta.io/js/latest/conekta.js";
		script.async = true;
		script.onload = () => {
			if (window.Conekta) {
				conektaHelper.initConekta();
			}
		};
		document.body.appendChild(script);

		global.Fin = 0;
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;

		var idCliente = "";
		if (props.match?.params?.id !== undefined) {
			setState((prev) => ({
				...prev,
				VerTiendaArtista: true,
				id: props.match.params.id,
			}));
			idCliente = props.match.params.id;
		} else {
			idCliente = userState.id;
			setState((prev) => ({
				...prev,
				VerTiendaArtista: false,
				id: userState.id,
			}));
			const newFetchPage = createFetchShopping(idCliente);
			setState((prev) => ({ ...prev, fetchPageFunction: newFetchPage }));
			const newFetchDesigns = createFetchDesigns(idCliente);
			setState((prev) => ({ ...prev, fetchDesignsFunction: newFetchDesigns }));
		}

		return () => {
			if (alertTimeoutRef.current) {
				clearTimeout(alertTimeoutRef.current);
			}
		};
	}, []);

	const handlePageChange = (event, newPage) => {
		var idCliente = userState.id;
		setState((prev) => ({
			...prev,
			currentPage: newPage,
			cargandoDisenios: true,
		}));
		ObtenerDisenosCliente(idCliente, newPage);
	};

	const obtenerEmpresa = (op) => {
		fetch(Globales.Url + "Empresa/Empresa", {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					if (op == 0) {
						setState((prev) => ({
							...prev,
							PrecioMembresia: data.data[0].PrecioMembresia,
						}));
						ObtenerMembresias();
					} else {
						setState((prev) => ({
							...prev,
							NombreEmpresa: data.data[0].NombreCortoEmpresa,
						}));
					}
				}
			});
	};

	const ObtenerMembresias = () => {
		fetch(Globales.Url + "ObtenerMembresiaVigente", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					if (data.data != null) {
						const Descuento =
							state.PrecioMembresia * (data.data.PorcentajeDescuento / 100);
						setState((prev) => ({
							...prev,
							DescuentoMembresia: data.data.PorcentajeDescuento,
							PrecioMembresiaDescuento: state.PrecioMembresia - Descuento,
							FechaVencimientoMembresia: data.data.FechaFinal,
						}));

						setState((prev) => ({
							...prev,
							isRequireDatosTarjetaMembresia:
								state.PrecioMembresiaDescuento == 0 ? false : true,
						}));
					}
				}
			});
	};

	const ObtenerInformacionCliente = async (id) => {
		setState((prev) => ({ ...prev, VerCargando: true }));
		const respuesta = await usersApi.getUserProfile({ _id: id });

		if (!respuesta.success) {
			Cookies.set("Mensaje", "Ocurrio un error intentelo mas tarde");
			Cookies.set("ColorMensaje", "danger");
			window.location.href = "/";
		} else {
			setState((prev) => ({
				...prev,
				BancoComision: respuesta.data.BancoComision,
				NumeroTarjetaComision: respuesta.data.NumeroTarjetaComision,
				EsRedSocial:
					respuesta.data.idTokenSocialNetwork != undefined ? true : false,
				IndicadorTerco: respuesta.data.IndicadorTerco,
				Saldo: respuesta.data.Saldo,
				id: respuesta.data._id,
				TipoUsuario: respuesta.data.TipoUsuario,
				Nombre: respuesta.data.Nombre,
				Correo: respuesta.data.Correo,
				ContrasenaActual: respuesta.data.Contrasena,
				Telefono: respuesta.data.Telefono,
				Usuario: respuesta.data.Usuario,
				Membresia: respuesta.data.Membresia,
				IndexTabArtista: respuesta.data.Membresia == false ? 2 : 0,
				IndexTabCliente: 0,
				Portada:
					respuesta.data.ImagenPortada == null
						? null
						: "data:image/png;base64," + respuesta.data.ImagenPortada,
				FotoPerfil:
					respuesta.data.FotoPerfil == null
						? null
						: "data:image/png;base64," + respuesta.data.FotoPerfil,
			}));

			if (localStorage.getItem("VerCompras") != undefined) {
				if (respuesta.data.TipoUsuario == "Cliente") {
					setState((prev) => ({ ...prev, IndexTabCliente: 1 }));
				} else {
					setState((prev) => ({ ...prev, IndexTabArtista: 1 }));
				}
				localStorage.removeItem("VerCompras");
			}

			setState((prev) => ({
				...prev,
				VerCargando: false,
				VerTabs: true,
			}));
		}
	};

	const ObtenerImagenes = (id) => {
		fetch(
			Globales.Url +
				"UsuarioClientes/UsuarioClientes/ObtenerImagenesTiendaArtista",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({ _id: id }),
			}
		)
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					setState((prev) => ({
						...prev,
						RutaPortada: data.data.ImagenPortada,
						RutaFotoPerfil: data.data.FotoPerfil,
						RutaLogo: data.data.LogoTienda,
					}));
					editarPerfil();
				}
			});
	};

	const ObtenerCompras = () => {
		global.Fin += 10;
		setState((prev) => ({
			...prev,
			CargandoCompras: true,
		}));
		fetch(Globales.Url + "Compras/ObtenerComprasPorClientes", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			body: JSON.stringify({
				idCliente: userState.id,
				Fin: global.Fin,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					if (data.data.length < global.Fin) {
						if (data.data.length > 0) {
							if (global.Fin != 10) {
								showNotification("No se encontraron más compras", "warning");
							}
						}
					}

					data.data.map((m, index) => {
						if (!m.responseFromConekta) {
							m["responseFromConekta"] = { _json: { amount: 0 } };
						}

						if (m.Estatus == 0) {
							m.NombreEstatusPedido = "CANCELADO";
						}

						m.FechaProximoEstatus =
							m.FechaProximoEstatus || m.FechaExpiracionPago;
					});
					setState((prev) => ({
						...prev,
						Compras: data.data,
						CargandoCompras: false,
					}));
				}
			})
			.catch((error) => {
				console.log("ObtenerCompras error: ", error);
			});
	};

	const validarEmail = (correo) => {
		if (
			/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(
				correo
			)
		) {
			return true;
		} else {
			return false;
		}
	};

	const validarNumeroTelefono = (numero) => {
		return /^\d{10}$/.test(numero);
	};

	const ObtenerVentasArtista = () => {
		setState((prev) => ({
			...prev,
			CargandoVentas: true,
		}));
		fetch(Globales.Url + "Compras/ObtenerVentasPorArtista", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			body: JSON.stringify({
				idCliente: userState.id,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					if (data.data != null) {
						if (data.data.length < global.Fin) {
							if (data.data.length > 0) {
								if (global.Fin != 10) {
									showNotification("No se encontraron más compras", "warning");
								}
							}
						}
						var totalComisionesPendientes = 0;
						data.data.map((m, index) => {
							if (!m.responseFromConekta) {
								m["responseFromConekta"] = { _json: { amount: 0 } };
							}
							if (m.Estatus == 0) {
								m.NombreEstatusPedido = "CANCELADO";
							}
						});
						setState((prev) => ({
							...prev,
							Ventas: data.data,
							CargandoVentas: false,
						}));
					} else {
						setState((prev) => ({
							...prev,
							CargandoVentas: false,
						}));
					}
				}
			});
	};

	const ObtenerComisionPorPagarArtista = () => {
		fetch(Globales.Url + "Compras/ObtenerComisionTotalPorArtista", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			body: JSON.stringify({
				idCliente: userState.id,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					setState((prev) => ({
						...prev,
						ImporteComisionesPendientes: data.data,
					}));
				}
			});
	};

	const validarCampos = () => {
		let valido = true;

		if (!state.Nombre) {
			showNotification("Favor de ingresar nombre", "danger");
			valido = false;
		}
		if (!validarNumeroTelefono(state.Telefono)) {
			showNotification(
				"Favor de ingresar número de teléfono a 10 digitos",
				"danger"
			);
			valido = false;
		}

		return valido;
	};

	const editarPerfil = async () => {
		if (!validarCampos()) {
			return;
		}

		const respuesta = await usersApi.updateUserProfile({
			_id: state.id,
			name: state.Nombre,
			phone: state.Telefono,
		});

		if (!respuesta.success) {
			showNotification(respuesta.message, "danger");
		} else {
			Cookies.getJSON("Nombre", state.Nombre);
			Cookies.getJSON("Telefono", state.Telefono);
			setState((prev) => ({
				...prev,
				errorTelefono: false,
				errorCorreo: false,
			}));
			showNotification("Perfil actualizado", "success");
		}
	};

	const ActualizarTarjetaComisiones = () => {
		var valido = true;

		if (state.BancoComision == "") {
			valido = false;
			setState((prev) => ({ ...prev, errorBancoComision: true }));
		} else {
			setState((prev) => ({ ...prev, errorBancoComision: false }));
		}

		if (state.NumeroTarjetaComision == "") {
			valido = false;
			setState((prev) => ({ ...prev, errorNumeroTarjetaComision: true }));
		} else {
			setState((prev) => ({ ...prev, errorNumeroTarjetaComision: false }));
		}

		if (valido == true) {
			fetch(
				Globales.Url +
					"UsuarioClientes/UsuarioClientes/ActualizarTarjetaComision",
				{
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: Globales.token,
					},
					body: JSON.stringify({
						idCliente: userState.id,
						Tarjeta: state.NumeroTarjetaComision,
						Banco: state.BancoComision,
					}),
				}
			)
				.then((res) => res.json())
				.then((data) => {
					if (data.error) {
						showNotification(
							"Ocurrió un error al actualizar la información",
							"danger"
						);
					} else {
						showNotification("Información Actualizada", "success");
					}
				});
		}
	};

	const ObtenerDisenosCliente = (id, pagina) => {
		setState((prev) => ({
			...prev,
			cargandoDisenios: true,
		}));
		const porPagina = state.itemsPerPage;
		fetch(
			Globales.Url +
				"DisenoProductos/DisenoProductos/ListarDisenosPorClientePerfil",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({
					idCliente: id,
					pagina: pagina,
					itemPorPagina: porPagina,
				}),
			}
		)
			.then((res) => res.json())
			.then((Disenos) => {
				if (Disenos.error) {
				} else {
					var disenosMostrar = [];
					Disenos.data.map((m) => {
						if (m.idDisenoPadre == null) {
							disenosMostrar.push(m);
						}
					});
					setState((prev) => ({
						...prev,
						Disenos: disenosMostrar,
						cargandoDisenios: false,
						totalProductos: Disenos.totalRegistros,
					}));
				}
			});
	};

	const AgregarDisenoATienda = (Diseno) => {
		setState((prev) => ({
			...prev,
			VerTienda: false,
			CuerpoCargando: "Agregando a tienda",
			VerCargando: true,
		}));

		fetch(
			Globales.Url +
				"DisenoProductos/DisenoProductos/AgregarYCrearDisenosTienda",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({ idDiseno: Diseno._id }),
			}
		)
			.then((res) => res.json())
			.then((Disenos) => {
				if (Disenos.error) {
					showNotification("Ocurrio un error", "danger");
				} else {
					setState((prev) => ({
						...prev,
						VerTienda: true,
						VerCargando: false,
						CuerpoCargando: "",
					}));
					ObtenerDisenosCliente(state.id, state.currentPage);
					showNotification("Producto agregado a tienda", "success");
				}
			});
	};

	const EliminarDisenoTienda = (id) => {
		setState((prev) => ({
			...prev,
			VerTienda: false,
		}));
		fetch(
			Globales.Url + "DisenoProductos/DisenoProductos/EliminarDisenoTienda",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({ idDiseno: id }),
			}
		)
			.then((res) => res.json())
			.then((Disenos) => {
				if (Disenos.error) {
					showNotification("Ocurrio un error", "danger");
				} else {
					setState((prev) => ({
						...prev,
						VerTienda: true,
					}));
					showNotification("Producto eliminado", "success");
				}
			});
	};

	const EliminarFavorito = (id) => {
		setState((prev) => ({
			...prev,
			VerTienda: false,
		}));
		fetch(Globales.Url + "Favoritos/EliminarDisenoFavoritos", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			body: JSON.stringify({ idDiseno: id, idCliente: state.id }),
		})
			.then((res) => res.json())
			.then((Disenos) => {
				if (Disenos.error) {
					showNotification("Ocurrio un error", "danger");
				} else {
					setState((prev) => ({
						...prev,
						VerTienda: true,
					}));
					showNotification("Producto eliminado", "success");
					if (!state.VerTiendaArtista) {
						ObtenerProductosDeseos();
					}
				}
			});
	};

	const ObtenerProductosDeseos = () => {
		fetch(
			Globales.Url + "ListaDeseos/ListaDeseos/ObtenerProductosListaDeseos",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({
					idCliente: userState.id,
				}),
			}
		)
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					var listaProductos = [];
					data.data.map((m) => {
						listaProductos.push(m.diseñoProducto);
					});
					setState((prev) => ({
						...prev,
						Disenos: listaProductos,
					}));
				}
			});
	};

	const ObtenerInformacionMembresia = (id) => {
		fetch(
			Globales.Url +
				"UsuarioClientes/UsuarioClientes/ObtenerDatosTarjetaSuscripcion",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({ idUsuarioConekta: id }),
			}
		)
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
				} else {
					setState((prev) => ({
						...prev,
						DatosMembresia: data.data,
					}));
				}
			});
	};

	const EventoModalAgregarTienda = (e) => {
		setState((prev) => ({
			...prev,
			VerAgregarTienda: false,
		}));
	};

	const openModal = () => {
		setState((prev) => ({ ...prev, show: true }));
	};

	const eventoModal = (e, imagen) => {
		setState((prev) => ({ ...prev, show: false }));
		if (!e) {
			if (state.TituloModal == "Editar portada") {
				setState((prev) => ({
					...prev,
					Portada: imagen,
				}));
			}
			if (state.TituloModal == "Editar foto de perfil") {
				setState((prev) => ({
					...prev,
					FotoPerfil: imagen,
				}));
			}
			if (state.TituloModal == "Editar logo") {
				setState((prev) => ({
					...prev,
					Logo: imagen,
				}));
			}
		}
	};

	const eventoClose = (mensaje, colorNotificacion) => {
		setState((prev) => ({ ...prev, show: false }));

		if (mensaje !== "esc") {
			setState((prev) => ({
				...prev,
				mensaje: mensaje,
				colorNotificacion: colorNotificacion,
			}));
			showNotification();
		}
	};

	const eventoModalCancelarMembresia = (e) => {
		if (e == true) {
			setState((prev) => ({ ...prev, VerModalCancelarMembresia: false }));
			BajaMembresia();
		} else {
			setState((prev) => ({ ...prev, VerModalCancelarMembresia: false }));
		}
	};

	const EventoModalCorreo = () => {
		setState((prev) => ({
			...prev,
			VerModalCorreo: false,
		}));
	};

	const EventoModalEliminarCuenta = (confirmado) => {
		if (confirmado === true) {
			// Aquí se ejecutará la lógica para eliminar la cuenta
			// Por ahora solo cerramos el modal
			showNotification("Funcionalidad de eliminación de cuenta en desarrollo", "info");
		}
		setState((prev) => ({
			...prev,
			VerModalEliminarCuenta: false,
		}));
	};

	const CambiarLogo = () => {
		setState((prev) => ({
			...prev,
			show: true,
			TituloModal: "Editar logo",
		}));
	};

	const VerDetalleCompra = (Detalles, Tipo) => {
		if (Tipo == 0) {
			setState((prev) => ({ ...prev, EsVenta: false }));
		}

		if (Tipo == 1) {
			setState((prev) => ({ ...prev, EsVenta: true }));
		}
		setState((prev) => ({
			...prev,
			DetallesCompra: Detalles,
			VerDetalleCompra: !state.VerDetalleCompra,
		}));
	};

	const CambiarFormatoPrecio = (precio) => {
		return new Intl.NumberFormat("es-MX", {
			style: "currency",
			currency: "MXN",
			minimumFractionDigits: 2,
		}).format(precio);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (name == "NumeroTarjetaComision") {
			if (value != "") {
				if (value.length < 17) {
					if (!/^[0-9]+$/.test(value)) {
					} else {
						setState((prev) => ({ ...prev, [name]: value }));
					}
				} else {
					return;
				}
			} else {
				setState((prev) => ({ ...prev, [name]: value }));
			}
		} else if (name == "Telefono") {
			if ((value.length < 11 && /^[0-9]+$/.test(value)) || value == "") {
				setState((prev) => ({
					...prev,
					[name]: value,
				}));
			}
		} else {
			setState((prev) => ({
				...prev,
				[name]: value,
			}));
		}
	};

	const showNotification = (mensaje, color) => {
		var x = [];
		setState((prev) => ({
			...prev,
			br: true,
			mensaje: mensaje,
			colorNotificacion: color,
		}));
		alertTimeoutRef.current = setTimeout(() => {
			setState((prev) => ({ ...prev, br: false }));
		}, 3000);
	};

	const CambiarFormatoFecha = (Fecha) => {
		var fecha = new Date(Fecha);
		var fecha2 = fecha.toLocaleDateString("es-MX", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
		});
		return fecha2;
	};

	const CancelarPedido = (Fecha, FechaDeCompra, idCompra) => {
		setState((prev) => ({
			...prev,
			VerModalCancelar: true,
			idPedidoCancelacion: idCompra,
		}));
	};

	const PreguntarEliminarDiseño = (idDiseno) => {
		setState((prev) => ({
			...prev,
			VerModalEliminarDiseno: true,
			idDisenoEliminar: idDiseno,
		}));
	};

	const EventoModalEliminarDiseño = (e) => {
		setState((prev) => ({
			...prev,
			VerModalEliminarDiseno: false,
		}));
		if (e == true) {
			showNotification("Tu diseño ha sido eliminado", "success");
			if (loaderDesignRef.current) {
				loaderDesignRef.current.reset();
			}
		}
	};

	const EventoModalCancelar = (e) => {
		if (e == true) {
			showNotification("Tu pedido ha sido cancelado", "success");
			if (loaderOrdersRef.current) {
				loaderOrdersRef.current.reset();
			}
			global.Fin = 0;
		}
		setState((prev) => ({
			...prev,
			VerModalCancelar: false,
		}));
	};

	const EventoEliminarTienda = (e) => {
		ObtenerDisenosCliente(state.id, state.currentPage);
		if (e == true) {
			showNotification("Producto eliminado de tienda", "success");
		} else {
			showNotification("Ocurrio un error", "danger");
		}
	};

	const CambiarDisenosFavoritos = (Opcion) => {
		if (Opcion == 1) {
			ObtenerDisenosCliente(state.id, state.currentPage);
			setState((prev) => ({
				...prev,
				SeleccionDisenos: true,
				SeleccionFavoritos: false,
			}));
		}
		if (Opcion == 2) {
			if (!state.VerTiendaArtista) {
				ObtenerProductosDeseos();
			}

			setState((prev) => ({
				...prev,
				SeleccionDisenos: false,
				SeleccionFavoritos: true,
			}));
		}
	};

	const VolverDiseñar = (disenos) => {
		setDesingState({
			Name: disenos.Nombre || "",
			Description: disenos.Descripcion || "",
			type: 2,
			idModel: disenos.idModelo,
			idSize: disenos.idTalla,
			idCategory: disenos.idCategoria,
			id: disenos._id,
			Desing: JSON.stringify(disenos),
		});
		window.location.href = "/diseñador3D";
	};

	const handleChangeTarjeta = (e) => {
		const { name, value } = e.target;
		if (name == "NumeroTarjeta" || name == "CodigoSeguridad") {
			if (value != "") {
				if (!/^[0-9]+$/.test(value)) {
				} else {
					if (name == "NumeroTarjeta") {
						if (value.length < 17) {
							setState((prev) => ({ ...prev, [name]: value }));
						}
					}
					if (name == "CodigoSeguridad") {
						if (value.length < 4) {
							setState((prev) => ({ ...prev, [name]: value }));
						}
					}
				}
			} else {
				setState((prev) => ({ ...prev, [name]: value }));
			}
		}
		if (name == "Mes") {
			if (value == "") {
				setState((prev) => ({ ...prev, [name]: value }));
			} else {
				if (!/^[0-9]+$/.test(value)) {
				} else {
					if (Number.parseInt(value) < 13) {
						setState((prev) => ({ ...prev, [name]: value }));
					}
				}
			}
		}
		if (name == "Año") {
			if (value == "") {
				setState((prev) => ({ ...prev, [name]: value }));
			} else {
				if (!/^[0-9]+$/.test(value)) {
					setState((prev) => ({ ...prev, [name]: value }));
				} else {
					if (Number.parseInt(value) > 0 && Number.parseInt(value) < 100) {
						setState((prev) => ({ ...prev, [name]: value }));
					}
				}
			}
		}
		if (name == "NombreTitular") {
			const regexLetters = /^[A-Za-z\u00C0-\u017F\s]+$/;
			const isValid = regexLetters.test(value);
			if (isValid || value === "") {
				setState((prev) => ({ ...prev, [name]: value }));
			}
		}
	};

	const ValidarDatos = (FormaPago, Campo) => {
		var err = state.error;
		var EventoTab = false;

		if (FormaPago == 0) {
			if (Campo == 1) {
				err.NumeroTarjeta = false;
				if (state.NumeroTarjeta == "" || state.NumeroTarjeta.length < 16) {
					err.NumeroTarjeta = true;
				}
			}
			if (Campo == 2) {
				err.NombreTitular = false;
				if (state.NombreTitular == "") {
					err.NombreTitular = true;
				}
			}
			if (Campo == 3) {
				err.Mes = false;
				if (state.Mes.length < 2) {
					err.Mes = true;
				}
			}

			if (Campo == 4) {
				err.Año = false;
				if (state.Año.length < 2) {
					err.Año = true;
				}
			}

			if (Campo == 5) {
				err.CodigoSeguridad = false;
				EventoTab = true;

				if (state.CodigoSeguridad.length < 3) {
					err.CodigoSeguridad = true;
				}
			}

			setState((prev) => ({
				...prev,
				error: err,
			}));
		}
	};

	const ValidarCompra = () => {
		if (state.isRequireDatosTarjetaMembresia) {
			conektaHelper.tokenize(
				state.NumeroTarjeta,
				state.NombreTitular,
				state.Mes,
				state.Año,
				state.CodigoSeguridad,
				successCallback,
				errorCallback
			);
		} else {
			AltaMembresia("");
		}
	};

	const successCallback = (token) => {
		AltaMembresia(token.id);
	};

	const errorCallback = (err) => {
		showNotification(err.message_to_purchaser, "warning");
	};

	const AltaMembresia = (token) => {
		setState((prev) => ({
			...prev,
			VerCargando: true,
			CuerpoCargando: "Generando membresía",
		}));
		fetch(Globales.Url + "Suscripciones/CrearSuscripcionCliente", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			body: JSON.stringify({
				idCliente: userState.id,
				NombreCliente: state.NombreTitular,
				TokenCard: token,
				isValorCero: !state.isRequireDatosTarjetaMembresia,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
					showNotification(data.mensaje, "warning");
					setState((prev) => ({
						...prev,
						VerCargando: false,
						CuerpoCargando: "",
					}));
				} else {
					setState((prev) => ({
						...prev,
						VerModalMembresia: true,
						VerCargando: false,
						CuerpoCargando: "",
					}));
					window.location.reload();
				}
			});
	};

	const BajaMembresia = () => {
		setState((prev) => ({
			...prev,
			VerCargando: true,
			CuerpoCargando: "Cancelando membresía",
		}));
		fetch(Globales.Url + "Suscripciones/CancelarSuscripcion", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			body: JSON.stringify({
				idCliente: userState.id,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error) {
					showNotification(data.mensaje, "warning");
					setState((prev) => ({
						...prev,
						VerCargando: false,
						CuerpoCargando: "",
					}));
				} else {
					setState((prev) => ({
						...prev,
						VerModalMembresia: true,
						VerCargando: false,
						CuerpoCargando: "",
						BajaMembresia: true,
					}));
				}
			});
	};

	// Render functions
	const imageClasses = classNames(
		classes.imgRaised,
		classes.imgRoundedCircle,
		classes.imgFluid
	);

	const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);

	const PagoTarjeta = (
		<div>
			<GridContainer justify="center">
				<GridItem xs={12} sm={4} md={6} lg={6}>
					<CustomInput
						labelText="Número de tarjeta"
						id="success"
						formControlProps={{
							fullWidth: true,
						}}
						inputProps={{
							required: state.isRequireDatosTarjetaMembresia,
							onChange: handleChange,
							onBlur: () => ValidarDatos(0, 1),
							value: state.NumeroTarjeta,
							name: "NumeroTarjeta",
							id: "NumeroTarjeta",
							type: "text",
							error: state.error.NumeroTarjeta,
							onKeyDown: handleChange,
						}}
					/>
				</GridItem>
				<GridItem xs={12} sm={4} md={6} lg={6}>
					<CustomInput
						labelText="Nombre del titular"
						id="success"
						formControlProps={{
							fullWidth: true,
						}}
						inputProps={{
							required: state.isRequireDatosTarjetaMembresia,
							onChange: handleChange,
							onBlur: () => ValidarDatos(0, 2),
							value: state.NombreTitular,
							autoComplete: "off",
							name: "NombreTitular",
							id: "NombreTitular",
							type: "text",
							error: state.error.NombreTitular,
						}}
					/>
				</GridItem>
			</GridContainer>

			<GridContainer justify="center">
				<GridItem xs={4} sm={4} md={2} lg={2}>
					<CustomInput
						labelText="Mes"
						id="success"
						formControlProps={{
							fullWidth: true,
						}}
						inputProps={{
							required: state.isRequireDatosTarjetaMembresia,
							onChange: handleChange,
							onBlur: () => ValidarDatos(0, 3),
							value: state.Mes,
							name: "Mes",
							id: "Mes",
							type: "text",
							error: state.error.Mes,
						}}
					/>
				</GridItem>
				<GridItem xs={4} sm={4} md={2} lg={2}>
					<CustomInput
						labelText="Año"
						id="success"
						formControlProps={{
							fullWidth: true,
						}}
						inputProps={{
							required: state.isRequireDatosTarjetaMembresia,
							onChange: handleChange,
							onBlur: () => ValidarDatos(0, 4),
							value: state.Año,
							name: "Año",
							id: "Año",
							type: "text",
							error: state.error.Año,
						}}
					/>
				</GridItem>
				<GridItem xs={4} sm={4} md={3} lg={3}>
					<CustomInput
						labelText="CVC"
						id="success"
						formControlProps={{
							fullWidth: true,
						}}
						inputProps={{
							required: state.isRequireDatosTarjetaMembresia,
							onChange: handleChange,
							onBlur: () => ValidarDatos(0, 5),
							value: state.CodigoSeguridad,
							autoComplete: "off",
							name: "CodigoSeguridad",
							id: "CodigoSeguridad",
							type: "password",
							error: state.error.CodigoSeguridad,
						}}
					/>
				</GridItem>
			</GridContainer>

			<GridContainer justify="center">
				<GridItem xs={12} sm={4} md={6} lg={6}>
					<br />
					<center>
						<Button
							onClick={() => ValidarCompra()}
							className="mt-5"
							id="BtnComprar"
							size="md"
							color="github"
						>
							{state.TipoUsuario == "Cliente"
								? "Conviertete en artista"
								: "Confirmar"}
						</Button>
					</center>
				</GridItem>
			</GridContainer>
		</div>
	);

	const Perfil = {
		tabButton: "Perfil",
		tabIcon: AccountCircle,
		tabContent: (
			<div>
				<GridContainer justify="center">
					<GridItem lg={10} md={10} sm={12} xs={12}>
						<GridContainer>
							<GridItem xs={12} sm={6} md={6}>
								<CustomInput
									labelText="Nombre"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										required: true,
										onChange: handleChange,
										value: state.Nombre,
										name: "Nombre",
										id: "Nombre",
										type: "text",
										error: state.errorNombre,
									}}
								/>
							</GridItem>
							<GridItem xs={12} sm={6} md={6}>
								<CustomInput
									labelText="Correo"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										required: true,
										onChange: handleChange,
										value: state.Correo,
										name: "Correo",
										id: "Correo",
										type: "email",
										disabled: true,
										error: state.errorCorreo,
									}}
								/>
							</GridItem>
						</GridContainer>
						<GridContainer>
							<GridItem xs={12} sm={6} md={6}>
								<CustomInput
									labelText="Teléfono"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										required: true,
										onChange: handleChange,
										value: state.Telefono,
										name: "Telefono",
										id: "Telefono",
										type: "number",
										error: state.errorTelefono,
									}}
								/>
							</GridItem>
							<GridItem xs={12} sm={6} md={6}>
								<CustomInput
									labelText="Créditos"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										required: true,
										onChange: handleChange,
										value: new Intl.NumberFormat("es-MX", {
											style: "currency",
											currency: "MXN",
										}).format(state.Saldo),
										name: "Saldo",
										id: "Saldo",
										type: "text",
										disabled: true,
									}}
								/>
							</GridItem>
						</GridContainer>
						<div className={classes.space50} />

						{state.EsRedSocial === false ? (
							<div>
								<h4 className={classes.modalTitle}>Cambiar contraseña</h4>

								<GridContainer>
									<GridItem xs={12} sm={6} md={6}>
										<CustomInput
											labelText="Contraseña Nueva"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												required: true,
												onChange: handleChange,
												value: state.ContrasenaNueva,
												name: "ContrasenaNueva",
												id: "ContrasenaNueva",
												type: "password",
												error: state.errorContrasenaNueva,
											}}
										/>
									</GridItem>
									<GridItem xs={12} sm={6} md={6}>
										<CustomInput
											labelText="Confirmación de Contraseña"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												required: true,
												onChange: handleChange,
												value: state.ConfirmacionContrasena,
												name: "ConfirmacionContrasena",
												id: "ConfirmacionContrasena",
												type: "password",
												error: state.errorConfirmacionContrasena,
											}}
										/>
									</GridItem>
								</GridContainer>
							</div>
						) : null}
					</GridItem>

					<GridItem lg={10} md={10} sm={12} xs={12}>
						<GridContainer justify="center">
							<Button
								size="md"
								onClick={() => ObtenerImagenes(state.id)}
								round
								color="success"
							>
								<Save /> Guardar
							</Button>
						</GridContainer>
					</GridItem>
					<GridItem lg={10} md={10} sm={12} xs={12}>
						<div className={classes.space50} />
						<GridContainer justify="center">
							<Button
								size="sm"
								onClick={() => {
									setState((prev) => ({
										...prev,
										VerModalEliminarCuenta: true,
									}));
								}}
								simple
								color="danger"
								style={{ 
									fontSize: "0.875rem",
									textTransform: "none"
								}}
							>
								<Delete style={{ fontSize: "18px", marginRight: "4px" }} /> 
								Eliminar cuenta
							</Button>
						</GridContainer>
					</GridItem>
				</GridContainer>
			</div>
		),
	};

	const Compras = {
		tabButton: "Compras",
		tabIcon: ShoppingBasket,
		tabContent: (
			<div>
				{state.VerDetalleCompra == false ? (
					<div>
						<GridContainer justify="center">
							<GridItem lg={12} md={12} sm={12} xs={12}>
								<Card>
									<CardBody>
										<GridContainer justify="center">
											<InfiniteLoader
												ref={loaderOrdersRef}
												key={state.infinitKeyShopping}
												fetchPage={state.fetchPageFunction}
												getItemKey={(item) => item._id}
												pageSize={6}
												autoLoad
												autoLoadUntil={2}
												showLoadMoreButton
												emptyComponent={<h3>Aún no tienes compras </h3>}
												loadingComponent={
													<GridContainer justify="center">
														{Array.from({ length: 6 }).map((_, i) => (
															<GridItem
																lg={12}
																md={12}
																sm={12}
																xs={12}
																key={i}
															>
																<PurchaseSkeletonCard />
															</GridItem>
														))}
													</GridContainer>
												}
												renderItem={(compra, index) => (
													<GridItem
														lg={12}
														md={12}
														sm={12}
														xs={12}
														key={compra._id}
													>
														<Card
															variant="outlined"
															style={{ margin: "5px 0" }}
														>
															<CardBody>
																<GridContainer>
																	<GridItem lg={6} md={6} sm={12} xs={12}>
																		<h4>
																			<b>Pedido N: {compra.FolioPedido}</b>
																		</h4>
																	</GridItem>
																	<GridItem
																		lg={6}
																		md={6}
																		sm={12}
																		xs={12}
																		style={{
																			textAlign: "right",
																			verticalAlign: "bottom",
																		}}
																	>
																		<span>
																			Pedido realizado:{" "}
																			{CambiarFormatoFecha(
																				compra.FechaDeCompra
																			)}{" "}
																		</span>
																	</GridItem>
																	<GridItem
																		lg={6}
																		md={6}
																		sm={12}
																		xs={12}
																		style={{ margin: "5px 0" }}
																	>
																		<span>
																			{compra.Estatus == 0
																				? "CANCELADO"
																				: !compra.EstatusPago
																				? "PENDIENTE DE PAGO"
																				: compra.NombreEstatusPedido ||
																				  "DESCONOCIDO"}
																		</span>
																		{compra.Estatus == 1 &&
																			!compra.EstatusPago &&
																			compra.responseFromConekta?.charges?._json
																				?.data?.[0]?.payment_method?.object ==
																				"cash_payment" && (
																				<Tooltip
																					title="Reenviar ficha de oxxo"
																					placement="top"
																				>
																					<IconButton
																						onClick={() =>
																							setState((prev) => ({
																								...prev,
																								VerModalCorreo: true,
																								DetallesCompra: compra,
																							}))
																						}
																					>
																						<Button
																							color="primary"
																							round
																							justIcon
																							size="sm"
																						>
																							<Mail />
																						</Button>
																					</IconButton>
																				</Tooltip>
																			)}
																	</GridItem>
																	<GridItem
																		lg={6}
																		md={6}
																		sm={12}
																		xs={12}
																		style={{ textAlign: "right" }}
																	>
																		<span>
																			Total:{" "}
																			{CambiarFormatoPrecio(
																				compra.responseFromConekta?._json
																					.amount || compra.PrecioPublico
																			)}{" "}
																		</span>
																	</GridItem>
																	<GridItem
																		lg={12}
																		md={12}
																		sm={12}
																		xs={12}
																		style={{ textAlign: "right" }}
																	>
																		<span
																			onClick={() =>
																				VerDetalleCompra(compra, 0)
																			}
																			style={{
																				textDecoration: "underline",
																				cursor: "pointer",
																			}}
																		>
																			{state.VerDetalleCompra
																				? "Ocultar"
																				: "Detalles"}
																		</span>
																	</GridItem>
																</GridContainer>
															</CardBody>
														</Card>
													</GridItem>
												)}
											/>
										</GridContainer>
									</CardBody>
								</Card>
							</GridItem>
						</GridContainer>
					</div>
				) : null}

				<div>
					{state.VerDetalleCompra == true ? (
						<DetalleVenta
							DetallesCompra={state.DetallesCompra}
							eventoCerrarDetalles={() =>
								setState((prev) => ({ ...prev, VerDetalleCompra: false }))
							}
							onCancelarPedido={CancelarPedido}
							CambiarFormatoFecha={CambiarFormatoFecha}
						/>
					) : null}
				</div>
			</div>
		),
	};

	const Membresia = {
		tabButton: "Membresia",
		tabIcon: CardMembership,
		tabContent: (
			<div>
				{state.Membresia == true ? (
					<div>
						<GridContainer justify="center">
							<GridItem xs={10} sm={6} md={6} lg={6}>
								<Card>
									<CardHeader color="primary">Información de pago</CardHeader>
									<CardBody>
										<GridContainer>
											<GridItem>
												<br />
												<span>
													Cargo mensual de{" "}
													{"$" +
														Number.parseFloat(
															state.DatosMembresia.Costo == undefined
																? 0
																: state.DatosMembresia.Costo / 100,
															10
														)
															.toFixed(2)
															.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
															.toString()}{" "}
													a tarjeta {state.DatosMembresia.brand} terminada en{" "}
													{state.DatosMembresia.last4}.
												</span>

												<br />
												<br />
											</GridItem>
										</GridContainer>

										<GridContainer justify="center">
											<Button
												onClick={() =>
													setState((prev) => ({
														...prev,
														VerModalCancelarMembresia: true,
													}))
												}
												color="github"
												size="sm"
											>
												Cancelar membresía
											</Button>
										</GridContainer>
									</CardBody>
								</Card>
							</GridItem>
						</GridContainer>

						<GridContainer justify="center">
							<GridItem xs={10} sm={6} md={6} lg={6}>
								<Card>
									<CardHeader color="primary">
										Tarjeta para depósito de comisiones
									</CardHeader>
									<CardBody>
										<GridContainer>
											<GridItem xs={12} sm={6} md={6}>
												<CustomInput
													labelText="Banco"
													formControlProps={{
														fullWidth: true,
													}}
													inputProps={{
														required: true,
														onChange: handleChange,
														value: state.BancoComision,
														name: "BancoComision",
														id: "BancoComision",
														type: "text",
														error: state.errorBancoComision,
													}}
												/>
											</GridItem>
											<GridItem xs={12} sm={6} md={6}>
												<CustomInput
													labelText="Número de tarjeta"
													formControlProps={{
														fullWidth: true,
													}}
													inputProps={{
														required: true,
														onChange: handleChange,
														value: state.NumeroTarjetaComision,
														name: "NumeroTarjetaComision",
														id: "NumeroTarjetaComision",
														type: "text",
														error: state.errorNumeroTarjetaComision,
													}}
												/>
											</GridItem>
										</GridContainer>

										<GridContainer justify="center">
											<Button
												onClick={() => ActualizarTarjetaComisiones()}
												color="github"
												size="sm"
											>
												Guardar
											</Button>
										</GridContainer>
									</CardBody>
								</Card>
							</GridItem>
						</GridContainer>
					</div>
				) : (
					<div>
						<GridContainer justify="center">
							<GridItem xs={10} sm={10} md={6} lg={6}>
								<Card>
									<CardHeader color="primary">Membresía</CardHeader>
									<CardBody>
										<GridContainer>
											<GridItem lg={12} md={12} sm={12} xs={12}>
												{state.PrecioMembresiaDescuento >= 0 ? (
													<center>
														<span
															style={{
																textDecoration: "line-through",
																color: "#f44336",
																fontSize: "1.1em",
															}}
														>
															{"$" +
																Number.parseFloat(state.PrecioMembresia, 10)
																	.toFixed(2)
																	.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
																	.toString()}
														</span>
													</center>
												) : null}
											</GridItem>

											<GridItem lg={12} md={12} sm={12} xs={12}>
												<center>
													<span style={{ fontSize: "3em", fontWeight: "2em" }}>
														{state.PrecioMembresiaDescuento == -1
															? "$" +
															  Number.parseFloat(state.PrecioMembresia, 10)
																	.toFixed(2)
																	.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
																	.toString()
															: "$" +
															  Number.parseFloat(
																	state.PrecioMembresiaDescuento,
																	10
															  )
																	.toFixed(2)
																	.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
																	.toString()}
													</span>
												</center>
											</GridItem>

											<GridItem lg={12} md={12} sm={12} xs={12}>
												{state.PrecioMembresiaDescuento != -1 ? (
													<center>
														<span
															style={{
																color: "#808080",
																fontSize: "1.1em",
																marginTop: "10px",
															}}
														>
															{"Vencimiento: " +
																new Date(
																	new Date(
																		state.FechaVencimientoMembresia
																	).setDate(
																		new Date(
																			state.FechaVencimientoMembresia
																		).getDate() + 1
																	)
																).toLocaleDateString("fr-CA", {
																	year: "numeric",
																	month: "2-digit",
																	day: "2-digit",
																})}
														</span>
													</center>
												) : null}
											</GridItem>
										</GridContainer>
										<GridContainer justify="center">
											<GridItem lg={12} md={12} sm={12} xs={12}>
												{PagoTarjeta}
											</GridItem>
										</GridContainer>
									</CardBody>
								</Card>
							</GridItem>
						</GridContainer>
					</div>
				)}
			</div>
		),
	};

	const Ventas = {
		tabButton: "Ventas",
		tabIcon: AttachMoney,
		tabContent: (
			<div>
				{state.Membresia == true ? (
					<div>
						{state.Ventas.length > 0 && state.CargandoVentas == false ? (
							<div>
								{state.VerDetalleCompra == false ? (
									<GridContainer justify="center" style={{ marginTop: "50px" }}>
										<GridItem lg={10} md={10} sm={12} xs={12}>
											<div
												className={classNames(classes.main, classes.mainRaised)}
											>
												<div className={classes.container}>
													<Card plain>
														<CardBody plain>
															<h3 className={classes.cardTitle}> </h3>
															<div
																style={{
																	backgroundColor: "#DEDEDE",
																	padding: "10px",
																	maxWidth: "300px",
																	borderRadius: "5px",
																}}
															>
																<h4>
																	{"Comisión Pendiente: $" +
																		new Intl.NumberFormat("es-MX", {
																			style: "currency",
																			currency: "MXN",
																		}).format(
																			state.ImporteComisionesPendientes
																		)}{" "}
																</h4>
															</div>

															<Table
																tableHead={[
																	"PEDIDO",
																	"FECHA",
																	"ESTATUS",
																	"TOTAL",
																]}
																tableData={state.Ventas.map((compra, index) => [
																	<span key={index + "_pedido"}>
																		{compra.FolioPedido}
																	</span>,
																	<span key={index + "_fecha"}>
																		{CambiarFormatoFecha(compra.FechaDeCompra)}
																	</span>,
																	<span key={index + "_estatus"}>
																		{compra.NombreEstatusPedido == undefined
																			? "Pendiente de pago"
																			: compra.NombreEstatusPedido}
																	</span>,
																	<span key={index + "_total"}>
																		{CambiarFormatoPrecio(
																			compra.responseFromConekta?._json
																				.amount || 0
																		)}
																	</span>,
																	<span
																		key={index + "_detalles"}
																		onClick={() => VerDetalleCompra(compra, 1)}
																		style={{
																			textDecoration: "underline",
																			cursor: "pointer",
																		}}
																	>
																		{" "}
																		{state.VerDetalleCompra
																			? "Ocultar"
																			: "Detalles"}{" "}
																	</span>,
																])}
																tableShopping
																customHeadCellClasses={[
																	classes.textCenter,
																	classes.description,
																	classes.description,
																	classes.textRight,
																	classes.textRight,
																	classes.textRight,
																]}
																customCellClasses={[
																	classes.tdName,
																	classes.customFont,
																	classes.customFont,
																	classes.tdNumber,
																	classes.tdNumber +
																		" " +
																		classes.tdNumberAndButtonGroup,
																	classes.tdNumber + " " + classes.textCenter,
																]}
															/>
														</CardBody>
													</Card>
												</div>
											</div>
										</GridItem>
									</GridContainer>
								) : null}

								<div>
									{state.VerDetalleCompra == true ? (
										<DetalleVenta
											EsVenta={state.EsVenta}
											DetallesCompra={state.DetallesCompra}
											eventoCerrarDetalles={() =>
												setState((prev) => ({
													...prev,
													VerDetalleCompra: false,
												}))
											}
											onCancelarPedido={CancelarPedido}
											CambiarFormatoFecha={CambiarFormatoFecha}
										/>
									) : null}
									<br />
								</div>
							</div>
						) : (
							<GridContainer justify="center">
								<GridItem lg={12} md={12} sm={12} xs={12}>
									<center>
										{state.CargandoVentas == true ? (
											<div>
												<h3>Obteniendo ventas</h3>

												<Loader
													visible={true}
													type="Oval"
													color="#212121"
													height={20}
													width={20}
												/>
											</div>
										) : null}

										{state.CargandoVentas == false ? (
											<h3>Aún no tienes ventas </h3>
										) : null}
									</center>
								</GridItem>
							</GridContainer>
						)}
					</div>
				) : (
					<center>
						<h4>Termina tu registro</h4>
					</center>
				)}
			</div>
		),
	};

	const Disenos = {
		tabButton: "Diseños",
		tabIcon: Camisa,
		tabContent: (
			<div>
				<GridContainer justify="center">
					<GridItem xs={12} sm={12} md={12}>
						<GridContainer justify="center">
							<InfiniteLoader
								ref={loaderDesignRef}
								key={state.infinitKeyDesigns}
								fetchPage={state.fetchDesignsFunction}
								getItemKey={(item) => item._id}
								pageSize={9}
								autoLoad
								autoLoadUntil={2}
								showLoadMoreButton
								emptyComponent={<h3>Aún no tienes diseños </h3>}
								renderItem={(design, index) => (
									<GridItem xs={12} sm={12} md={6} lg={4} key={design._id}>
										<div style={{ minWidth: "300px" }}>
											<center>
												<img
													style={{
														width: "250px",
														height: "250px",
														objectFit: "cover",
														objectPosition: "center center",
													}}
													src={design.DesignImage || "/placeholder.svg"}
													alt="..."
												/>
											</center>
										</div>
										<center>
											<h4
												style={{ marginTop: "-10px", marginBottom: "0" }}
												className={classes.cardTitle}
											>
												{design.nombre}
											</h4>

											<Tooltip
												title="Editar diseño"
												placement="top"
												classes={{ tooltip: classes.tooltip }}
											>
												<IconButton
													onClick={() => VolverDiseñar(design)}
													aria-label="Editar diseño"
												>
													<Edit fontSize="small" color="action" />
												</IconButton>
											</Tooltip>

											{state.Membresia == true &&
											state.SeleccionDisenos == true &&
											state.TipoUsuario == "Artista" ? (
												<Tooltip
													disabled={design.EnTienda == true ? true : false}
													title="Añadir a mi tienda"
													placement="top"
													classes={{ tooltip: classes.tooltip }}
												>
													<IconButton
														onClick={() => AgregarDisenoATienda(design)}
														fontSize="small"
														color="action"
														aria-label="Añadir a mi tienda"
													>
														<StoreMallDirectory />
													</IconButton>
												</Tooltip>
											) : null}

											{state.SeleccionDisenos == true ? (
												<Tooltip
													disabled={design.EnTienda == true ? true : false}
													title={
														design.EnTienda == true
															? "Diseño en tienda"
															: "Eliminar diseño"
													}
													placement="top"
													classes={{ tooltip: classes.tooltip }}
												>
													<IconButton
														onClick={() => PreguntarEliminarDiseño(design._id)}
														fontSize="small"
														color="action"
														aria-label="Eliminar diseño"
													>
														<Delete />
													</IconButton>
												</Tooltip>
											) : (
												<Tooltip
													title={"Eliminar"}
													placement="top"
													classes={{ tooltip: classes.tooltip }}
												>
													<IconButton
														onClick={() => EliminarFavorito(design._id)}
														fontSize="small"
														color="action"
														aria-label="Eliminar"
													>
														<Delete />
													</IconButton>
												</Tooltip>
											)}
										</center>
									</GridItem>
								)}
							/>
						</GridContainer>
					</GridItem>
				</GridContainer>
			</div>
		),
	};

	const Tienda = {
		tabButton: "tienda",
		tabIcon: StoreMallDirectory,
		tabContent: (
			<div>
				{state.Membresia == true ? (
					state.VerTienda == true ? (
						<TiendaArtista
							TiendaPropia={state.VerTiendaArtista}
							idCliente={userState.id}
							EventoEliminarTienda={EventoEliminarTienda}
						/>
					) : null
				) : (
					<center>
						<h4>Termina tu registro</h4>
					</center>
				)}
			</div>
		),
	};

	const Artista = {
		tabButton: "¡Artista!",
		tabIcon: Grade,
		tabContent: (
			<div>
				<GridContainer />

				<GridContainer justify="center">
					<GridItem xs={10} sm={10} md={6} lg={6}>
						<Card>
							<CardHeader color="primary">Membresía</CardHeader>
							<CardBody>
								<GridContainer>
									<GridItem lg={12} md={12} sm={12} xs={12}>
										{state.PrecioMembresiaDescuento >= 0 ? (
											<center>
												<span
													style={{
														textDecoration: "line-through",
														color: "#f44336",
														fontSize: "1.1em",
													}}
												>
													{"$" +
														Number.parseFloat(state.PrecioMembresia, 10)
															.toFixed(2)
															.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
															.toString()}
												</span>
											</center>
										) : null}
									</GridItem>

									<GridItem lg={12} md={12} sm={12} xs={12}>
										<center>
											<span style={{ fontSize: "3em", fontWeight: "2em" }}>
												{state.PrecioMembresiaDescuento == -1
													? "$" +
													  Number.parseFloat(state.PrecioMembresia, 10)
															.toFixed(2)
															.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
															.toString()
													: "$" +
													  Number.parseFloat(
															state.PrecioMembresiaDescuento,
															10
													  )
															.toFixed(2)
															.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
															.toString()}
											</span>
										</center>
									</GridItem>

									<GridItem lg={12} md={12} sm={12} xs={12}>
										{state.PrecioMembresiaDescuento >= 0 ? (
											<center>
												<span
													style={{
														color: "#808080",
														fontSize: "1.1em",
														marginTop: "10px",
													}}
												>
													{"Vencimiento: " +
														new Date(
															new Date(state.FechaVencimientoMembresia).setDate(
																new Date(
																	state.FechaVencimientoMembresia
																).getDate() + 1
															)
														).toLocaleDateString("fr-CA", {
															year: "numeric",
															month: "2-digit",
															day: "2-digit",
														})}
												</span>
											</center>
										) : null}
									</GridItem>
								</GridContainer>
								<GridContainer justify="center">
									<GridItem lg={12} md={12} sm={12} xs={12}>
										{PagoTarjeta}
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div>
		),
	};

	return (
		<div>
			<Header
				color="dark"
				links={<HeaderLinks dropdownHoverColor="dark" />}
				fixed
				{...rest}
			/>
			<Parallax
				image={state.Portada == null ? BannerPerfilArtistas : state.Portada}
				className={classes.parallax}
				style={{ marginBottom: "120px", marginTop: "0px" }}
			/>
			<div
				className={classNames(classes.main, classes.mainRaised)}
				style={{
					minHeight: "calc(100vh - 500px)",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					className={classes.container}
					style={{ flex: 1, display: "flex", flexDirection: "column" }}
				>
					<GridContainer justify="center">
						<GridItem xs={12} sm={6} md={6}>
							<div className={classes.profile}>
								{state.VerTiendaArtista == true ? (
									<div
										id="ContenedorImagenPerfil"
										className="ContenedorImagenPerfil"
									>
										{state.VerTiendaArtista == false ? (
											<img
												onClick={() =>
													setState((prev) => ({
														...prev,
														show: true,
														TituloModal: "Editar foto de perfil",
													}))
												}
												style={{
													cursor: "pointer",
													backgroundColor: "white",
													borderRadius: "50%",
													objectFit: "cover",
												}}
												src={
													state.FotoPerfil == null
														? UsuarioBlanco
														: state.FotoPerfil || "/placeholder.svg"
												}
												height="150px"
											/>
										) : (
											<img
												src={
													state.FotoPerfil == null
														? UsuarioBlanco
														: state.FotoPerfil || "/placeholder.svg"
												}
												style={{
													backgroundColor: "white",
													borderRadius: "50%",
													objectFit: "cover",
												}}
												height="150px"
											/>
										)}
									</div>
								) : (
									<div
										id="ContenedorImagenPerfil"
										className="ContenedorImagenPerfil"
									>
										<img
											onClick={() =>
												setState((prev) => ({
													...prev,
													show: true,
													TituloModal: "Editar foto de perfil",
												}))
											}
											style={{
												cursor: "pointer",
												backgroundColor: "white",
												borderRadius: "50%",
												objectFit: "cover",
											}}
											onMouseOver={() =>
												setState((prev) => ({
													...prev,
													VerBotonFotoPerfil: true,
												}))
											}
											onMouseOutCapture={() =>
												setState((prev) => ({
													...prev,
													VerBotonFotoPerfil: false,
												}))
											}
											src={
												state.FotoPerfil == null
													? UsuarioBlanco
													: state.FotoPerfil || "/placeholder.svg"
											}
											width="150px"
											height="150px"
										/>
										{state.VerBotonFotoPerfil ? (
											<button id="btnImagen" className="btnImagen">
												Editar
											</button>
										) : null}
									</div>
								)}

								<div className={classes.name}>
									<h3> {state.Nombre} </h3>
								</div>
							</div>
							{state.VerTiendaArtista == false ? (
								<div className={classes.follow}>
									<Tooltip
										id="tooltip-top"
										title="Editar Portada"
										placement="top"
										classes={{ tooltip: classes.tooltip }}
									>
										<Button
											justIcon
											round
											color="github"
											className={classes.followButton}
											onClick={() =>
												setState((prev) => ({
													...prev,
													show: true,
													TituloModal: "Editar portada",
												}))
											}
										>
											<Edit className={classes.followIcon} />
										</Button>
									</Tooltip>
								</div>
							) : null}
						</GridItem>
					</GridContainer>

					{state.VerTiendaArtista == true ? (
						<GridContainer>
							<GridItem lg={12} md={12} sm={12} xs={12}>
								<TiendaArtista
									TiendaPropia={state.VerTiendaArtista}
									idCliente={state.id}
									EventoEliminarTienda={EventoEliminarTienda}
								/>
							</GridItem>
						</GridContainer>
					) : (
						<div className={classes.profileTabs} style={{ marginTop: "0px" }}>
							{state.VerTabs == true ? (
								state.TipoUsuario == "Cliente" ? (
									<NavPills
										active={state.IndexTabCliente}
										alignCenter
										color="primary"
										tabs={[Perfil, Compras, Disenos]}
									/>
								) : state.TipoUsuario == "Artista" &&
								  state.IndicadorTerco == true ? (
									<NavPills
										active={state.IndexTabArtista}
										alignCenter
										color="primary"
										tabs={[Perfil, Compras, Ventas, Disenos, Tienda]}
									/>
								) : (
									<NavPills
										active={state.IndexTabArtista}
										alignCenter
										color="primary"
										tabs={[Perfil, Compras, Membresia, Ventas, Disenos, Tienda]}
									/>
								)
							) : null}
						</div>
					)}
				</div>
			</div>
			<Snackbar
				place="tr"
				color={state.colorNotificacion}
				message={state.mensaje}
				open={state.br}
				closeNotification={() => setState((prev) => ({ ...prev, br: false }))}
				close
			/>
			{state.VerAgregarTienda == true ? (
				<ModalAgregarTienda
					Disenos={state.DisenosGrupo}
					EventoModalAgregarTienda={EventoModalAgregarTienda}
					VerAgregarTienda={state.VerAgregarTienda}
				/>
			) : null}
			{state.show ? (
				<div id="">
					<ModalEditar
						Titulo={state.TituloModal}
						liveDemo={state.show}
						Imagenes={{
							Portada: state.Portada,
							FotoPerfil: state.FotoPerfil,
							Logo: state.Logo,
						}}
						size="large"
						eventClick={eventoModal}
						eventClose={eventoClose}
					/>
				</div>
			) : null}
			{state.VerModalEliminarDiseno == true ? (
				<ModalEliminarDiseño
					Show={state.VerModalEliminarDiseno}
					idDiseno={state.idDisenoEliminar}
					eventClick={EventoModalEliminarDiseño}
				/>
			) : null}
			{state.VerModalCancelar == true ? (
				<ModalCancelar
					VerModalCancelar={state.VerModalCancelar}
					FechaParaCancelar={state.FechaParaCancelar}
					EventoModalCancelar={EventoModalCancelar}
					idPedidoCancelacion={state.idPedidoCancelacion}
				/>
			) : null}
			{state.VerModalMembresia == true ? (
				<ModalMembresia
					VerModal={state.VerModalMembresia}
					TipoMensaje={state.BajaMembresia}
				/>
			) : null}
			{state.VerModalCancelarMembresia == true ? (
				<ModalCancelarMembresia
					Titulo="Cancelar membresía"
					body={"¿Seguro que deseas cancelar tu membresía?"}
					liveDemo={state.VerModalCancelarMembresia}
					eventClick={eventoModalCancelarMembresia}
				/>
			) : null}
			{state.VerModalCorreo == true ? (
				<ModalCorreoOxxo
					VerModal={state.VerModalCorreo}
					DetallesCompra={state.DetallesCompra}
					eventClick={EventoModalCorreo}
				/>
			) : null}
			{state.VerModalEliminarCuenta == true ? (
				<ModalEliminarCuenta
					open={state.VerModalEliminarCuenta}
					correoUsuario={state.Correo}
					eventClick={EventoModalEliminarCuenta}
				/>
			) : null}

			<ModalCargando Ver={state.VerCargando} Cuerpo={state.CuerpoCargando} />
		</div>
	);
};

export default withStyles(profilePageStyle)(ProfilePage);
